import { AddToTeamDialog } from "@components/table/members/add-to-team-dialog";
import { ADD_TO_TEAM_TITLE } from "@components/teams/add-to-team/add-to-team-constants";
import { MenuItem, TeamIcon } from "@flat-ui";
import { useState } from "react";
/** Menu item that adds a single workspace member to a team, after the team is picked in a dialog */
export function AddToTeamMenuButton({
  member,
  onMenuClose
}) {
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  return <>
      <MenuItem label={ADD_TO_TEAM_TITLE} Icon={TeamIcon} onClick={() => setIsDialogOpen(true)} />

      <AddToTeamDialog member={member} isOpen={isDialogOpen} onClose={closeDialog} />
    </>;

  /** Closes the dialog and the 3-dot menu it was opened from */
  function closeDialog() {
    setIsDialogOpen(false);
    onMenuClose();
  }
}